import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiTerminal, FiGlobe, FiCpu, FiShield } from 'react-icons/fi';
import { motion } from 'framer-motion';

const HeroTerminal = () => {
  return (
    <section className="relative pt-10 pb-20 px-4 overflow-hidden" id="dashboard">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-8 items-stretch">
          
          {/* Main Hero Panel */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="lg:col-span-8 dashboard-panel p-8 md:p-12 scanline overflow-hidden"
          >
            <div className="relative z-10 space-y-8">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-electric/10 border border-electric/30 text-electric fids-text text-[10px] rounded-full">
                <SafeIcon icon={FiTerminal} />
                <span>PROTOCOL_v4.2 // READY_FOR_DEPARTURE</span>
              </div>
              
              <h1 className="text-6xl md:text-8xl font-black tracking-tighter leading-[0.9] uppercase italic">
                Equip <br/>
                <span className="text-electric">Motion</span>
              </h1>
              
              <p className="text-gray-400 fids-text text-sm max-w-lg leading-relaxed">
                A modular ecosystem of power, connectivity, and protection hardware designed for those who live between time zones.
              </p>

              <div className="flex flex-wrap gap-4 pt-4">
                <button className="bg-electric text-graphite-900 fids-text font-bold px-8 py-4 hover:scale-105 transition-all flex items-center gap-3">
                  ACCESS INVENTORY
                  <span className="text-[10px] opacity-60"> [ENTER]</span>
                </button>
                <button className="border border-graphite-600 text-white fids-text px-8 py-4 hover:bg-white/5 transition-all">
                  VIEW SPECS
                </button>
              </div>
            </div>
          </motion.div>

          {/* Sidebar Status Panels */}
          <div className="lg:col-span-4 flex flex-col gap-6">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="dashboard-panel p-6 flex-1"
            >
              <div className="flex justify-between items-center mb-6 border-b border-graphite-700 pb-3">
                <span className="fids-text text-xs text-graphite-600">LIVE_METRICS</span>
                <SafeIcon icon={FiGlobe} className="text-electric animate-spin-slow" />
              </div>
              <div className="space-y-4 fids-text text-xs">
                <div className="flex justify-between">
                  <span className="text-gray-400">GLOBAL_NODES:</span>
                  <span className="text-white">12,402</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">UPTIME:</span>
                  <span className="text-green-400">99.998%</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">SYNC_STATUS:</span>
                  <span className="text-electric">OPTIMIZED</span>
                </div>
              </div>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="dashboard-panel p-6 bg-electric/5 border-electric/20"
            >
              <div className="flex items-center gap-3 mb-4">
                <SafeIcon icon={FiShield} className="text-electric text-xl" />
                <span className="fids-text text-xs font-bold">WARRANTY_PROTECT</span>
              </div>
              <p className="text-[10px] fids-text text-gray-400 mb-4">
                All KairoKit modules are covered by our 3-year "Zero-Downtime" international replacement policy.
              </p>
              <div className="h-1 bg-graphite-700 rounded-full overflow-hidden">
                <motion.div 
                  initial={{ width: 0 }}
                  animate={{ width: "100%" }}
                  transition={{ duration: 2 }}
                  className="h-full bg-electric shadow-[0_0_10px_#00E5FF]"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroTerminal;